import { defaultPathInfoData } from "../../../constants/pathInfo";
import PathInfo from "../../../PathInfo";
import WaysToTakeCourseTable from "../../../CertificateWaysToTakeCourse/WaysToTakeCourseTable";
import { PathInfo as PathInfoProps } from "./types";
import useTranslations from "@/i18n/useTranslations";

export interface PathInfoTabProps {
  externalData?: PathInfoProps;
  coursePrice: number;
  convertedPrice?: number | null;
  displayCurrency?: { code: string; symbol: string; rate: number };
  hidePrice?: boolean;
}

export default function PathInfoTab({
  externalData,
  coursePrice,
  convertedPrice,
  displayCurrency,
  hidePrice,
}: PathInfoTabProps) {
  const t = useTranslations("Course");
  const defaultAuditInfo = {
    header: t("audit"),
    info: t("auditPathInfo"),
  };
  const defaultCertificateInfo = {
    header: t("certificate"),
    info: t("certificatePathInfo"),
  };

  return (
    <>
      <PathInfo
        title={externalData?.title ?? t("chooseYourPathTitle")}
        auditInfo={externalData?.auditInfo ?? defaultAuditInfo}
        certificateInfo={
          externalData?.certificateInfo ?? defaultCertificateInfo
        }
        list={externalData?.list ?? defaultPathInfoData.list}
      />
      <WaysToTakeCourseTable
        coursePrice={coursePrice}
        convertedPrice={convertedPrice}
        displayCurrency={displayCurrency}
        hidePrice={hidePrice}
      />
    </>
  );
}
